// Config partagée client + admin.
// SÉCHERESSE : navigation suspendue sur le Doubs — formules bateau bloquées,
// départs calèche adaptés (10h00 / 14h30, 1h30 avec visite du belvédère).
// Pour rétablir la situation normale : passer SECHERESSE à false.
var SECHERESSE = true;
var DEPARTS = ["10:00", "13:45", "15:15"];
var DEPARTS_ACTIFS = SECHERESSE ? ["10:00", "14:30"] : DEPARTS;

// ── JOURS D'OUVERTURE ─────────────────────────────────────────────
// SOURCE UNIQUE cote client de la regle "ferme lundi, mardi, mercredi".
// Miroir de surabaya-backend/services/horaires.js : les deux fichiers
// doivent rester d'accord. Avant, la regle etait recopiee dans
// getSaison() et getRestoSaison() avec un perimetre different de celui
// du serveur, qui ne fermait que le restaurant.
var MOIS_ETE = [6, 7, 8];          // juin, juillet, aout : ouvert 7j/7
var JOURS_FERMES = [1, 2, 3];      // 0 = dimanche ... 1 = lundi, 2 = mardi, 3 = mercredi
var EXCEPTIONS_OUVERT = ['2026-04-06'];

function estJourFerme(dateStr) {
  var iso = String(dateStr || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;
  if (EXCEPTIONS_OUVERT.indexOf(iso) !== -1) return false;
  // Midi local, pas minuit : "2026-09-07" parse tel quel donne minuit UTC,
  // et un visiteur dans un fuseau negatif verrait dimanche au lieu de lundi.
  var d = new Date(iso + 'T12:00:00');
  if (isNaN(d.getTime())) return false;
  if (MOIS_ETE.indexOf(d.getMonth() + 1) !== -1) return false;
  return JOURS_FERMES.indexOf(d.getDay()) !== -1;
}

// Sommes-nous actuellement en horaires d'hiver ? (pilote le bandeau)
function estPeriodeHiver() {
  return MOIS_ETE.indexOf(new Date().getMonth() + 1) === -1;
}

module.exports = {
  SECHERESSE: SECHERESSE, DEPARTS: DEPARTS, DEPARTS_ACTIFS: DEPARTS_ACTIFS,
  MOIS_ETE: MOIS_ETE, JOURS_FERMES: JOURS_FERMES, EXCEPTIONS_OUVERT: EXCEPTIONS_OUVERT,
  estJourFerme: estJourFerme, estPeriodeHiver: estPeriodeHiver
};
